import { onMounted, onUnmounted } from 'vue'

/**
 * Анимация появления элементов `.reveal` при скролле.
 *
 * Скан по getBoundingClientRect (как в референсе) — добавляет класс `.in`, когда
 * элемент в пределах 90% вьюпорта. Базовое состояние держит opacity:1 (только
 * transform анимируется), плюс failsafe-таймер, чтобы контент никогда не остался
 * невидимым. Вызывать один раз — в корневом компоненте.
 */
export function useReveal(): void {
  let raf = 0
  let t1 = 0
  let t2 = 0
  let tAll = 0

  const show = (el: Element): void => {
    el.classList.add('in')
  }

  const scan = (): void => {
    const vh = window.innerHeight || document.documentElement.clientHeight
    document.querySelectorAll<HTMLElement>('.reveal:not(.in)').forEach((el) => {
      const rect = el.getBoundingClientRect()
      if (rect.top < vh * 0.9 && rect.bottom > 0) show(el)
    })
  }

  const onScroll = (): void => {
    cancelAnimationFrame(raf)
    raf = requestAnimationFrame(scan)
  }

  onMounted(() => {
    scan()
    requestAnimationFrame(scan)
    t1 = window.setTimeout(scan, 120)
    t2 = window.setTimeout(scan, 400)
    // Failsafe: ни при каких условиях не оставляем контент скрытым.
    tAll = window.setTimeout(() => {
      document.querySelectorAll<HTMLElement>('.reveal:not(.in)').forEach(show)
    }, 1400)
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onScroll)
    cancelAnimationFrame(raf)
    clearTimeout(t1)
    clearTimeout(t2)
    clearTimeout(tAll)
  })
}
